import SEO from "@/components/SEO";
import ServicesGrid from "@/components/ServicesGrid";
import { RevealBlock } from "@/components/Reveal";
import { services } from "@/data/services";

const DIRECTORIES = [
  "Halifax port-area business association listings",
  "Nova Scotia Construction Sector Council partner listings",
  "Halifax Chamber member directory",
];

export default function Services() {
  return (
    <>
      <SEO
        title="Security Services in Nova Scotia | Guards, Patrols & Events"
        description="Compare guard, mobile patrol, marine, event and industrial security options for Nova Scotia sites. Request a plan matched to access, hours and risks."
        path="/services"
        keywords={[
          "marine security Halifax",
          "construction security Dartmouth",
          "mobile patrol Truro",
          "event security Halifax",
          "security guards Sydney NS",
          ...services.flatMap((s) => s.keywords || []).slice(0, 40),
        ]}
      />
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-16 md:pt-24 pb-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-8">
          — {services.length} Disciplines
        </p>
        <RevealBlock>
          <h1 className="font-serif text-[clamp(2.75rem,7.5vw,8rem)] leading-[0.95] tracking-tighter text-[#111111]">
            Security services for<br />
            <span className="italic text-[#184C59]">Nova Scotia sites.</span>
          </h1>
        </RevealBlock>
        <p className="mt-8 font-sans text-lg text-[#111111]/70 max-w-[64ch] leading-relaxed">
          Explore the guard and patrol options that suit your operation. Each
          service page explains coverage, reporting and when a local supervisor
          is available.
        </p>
      </section>
      <ServicesGrid />

      <section className="bg-[#F5F3EF] border-t border-[#D9D6D0] py-16 md:py-20">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43]">
              — Industry references
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-serif text-2xl md:text-4xl text-[#111111] mb-6 leading-tight">
              Local directories & sector resources.
            </h2>
            <ul className="border-t border-[#D9D6D0]">
              {DIRECTORIES.map((d, i) => (
                <li
                  key={d}
                  className="border-b border-[#D9D6D0] py-5 grid grid-cols-12 gap-4"
                >
                  <span className="col-span-2 font-mono text-[10px] uppercase tracking-[0.28em] text-[#C17A43]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="col-span-10 font-serif text-lg md:text-xl text-[#111111]">
                    {d}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
